// src/components/Clock.js
import React, { useState, useEffect } from 'react';

const Clock = () => {
  const [date, setDate] = useState(new Date());

  useEffect(() => {
    const timerID = setInterval(() => {
      setDate(new Date());
    }, 1000);

    return () => {
      clearInterval(timerID);
    };
  }, []);

  return (
    <div style={{
      padding: "0.5rem",
      margin: "1rem",
    border: "1px solid #ccc",
    width: "fit-content",
    borderRadius: "5px",
    }}>
      <p>Look Mom, I made a clock!</p>
      <h2>It is {date.toLocaleTimeString()}.</h2>
    </div>
  );
};

export default Clock;
